import React, { useEffect, useState } from "react";
import "react-sliding-pane/dist/react-sliding-pane.css";
import "jspdf-autotable";

import AllReciptReport from "./AllReceiptReport";
import UnappliedReciptReport from "./UnappliedReceiptsReport";
import AssetRegister from "./AssetRegister";
import AssetConcentration from "./AssetConcentration";
import AssetConcentrationByLoaction from "./AssetConcentrationbyloacation";

function InventoryReport({ id, setInventoryview }) {
    const [loading, setLoading] = useState(true);
    const [viewReceipts, setviewReceipts] = useState("inventoryreport");
    const [receipts, setReceipt] = useState(false);
    const [unappliedreceipts, setUnappliedreceipts] = useState(false);
    const [assetbylocation, setAssetByLoaction] = useState(false);

    useEffect(() => {
        setLoading(false);
    }, []);


    useEffect(() => {
        viewReceipts === "inventoryreport" ? setReceipt(true) : setReceipt(false);
        viewReceipts === "assetreport"
            ? setUnappliedreceipts(true)
            : setUnappliedreceipts(false);
        viewReceipts === "assetbylocationreport"
            ? setAssetByLoaction(true)
            : setAssetByLoaction(false);
    }, [viewReceipts]);

    useEffect(() => {
        setviewReceipts(setInventoryview)
    }, [setInventoryview]);

    return (
        <>
            {/* <div className="content container-fluid"> */}
                <div value={viewReceipts} className="pt-1">
                </div>
                <div className="body py-2">
                    <div className="col-md-12">
                        {receipts && <AssetRegister />}
                        {unappliedreceipts && <AssetConcentration />}
                        {assetbylocation && <AssetConcentrationByLoaction />}
                    </div>
                </div>
            {/* </div> */}
        </>
    );
}

export default InventoryReport;
